import {
  RedeemTxType,
  GoldWithdrawFilters,
  GoldWithdrawFilterKey,
  GoldWithdrawFilterValue,
} from 'src/type/gold-withdraw';
import {
  Card,
  Stack,
  Table,
  Button,
  TableBody,
  Container,
  Typography,
  TableContainer,
} from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import { isAfter } from 'src/utils/format-time';
import Scrollbar from 'src/components/scrollbar';
import TableHeadCustom from 'src/components/table/table-head-custom';
import TableEmptyRows from 'src/components/table/table-empty-rows';
import TableNoData from 'src/components/table/table-no-data';
import TablePaginationCustom from 'src/components/table/table-pagination-custom';
import { useBoolean } from 'src/hooks/use-boolean';
import usePagination from 'src/hooks/use-pagination';
import axios, { endpoints } from 'src/utils/axios';
import { fParams, fDateRange, ParamsType } from 'src/utils/format-params';
import { Pagination } from 'src/type/utils';
import { toastError } from 'src/utils/format-error';
import { TransactionType } from 'src/type/transaction';
import TableLoading from 'src/components/table/table-loading';
import { emptyRows } from 'src/components/table/utils';

import useProductOptions from 'src/hooks/use-product-options';
import LoadingDialog from 'src/components/ui-kit/loading-dialog';
import Iconify from 'src/components/iconify';
import StockExportCreateDialog from '../stock-export-create-dialog';
import StockExportTableRow from '../stock-export-table-row';
import StockExportTableFiltersResult from '../stock-export-table-filters-result';
import StockExportTableToolbar from '../stock-export-table-toolbar';

const defaultFilters: GoldWithdrawFilters = {
  name: null,
  productId: 'all',
  startDate: null,
  endDate: null,
  status: 'all',
};

const tableHead = [
  { id: 'ลูกค้า', label: 'ลูกค้า' },
  { id: 'product', label: 'สินค้า', width: 140 },
  { id: 'amount', label: 'น้ำหนัก', width: 120 },
  { id: 'price', label: 'ราคา', width: 120 },
  { id: 'createDate', label: 'วันที่ทำรายการ', width: 180 },
  { id: 'action', width: 60 },
];

export default function StockExportView() {
  const initialize = useBoolean(true);
  const loading = useBoolean();
  // const approve = useBoolean();
  const [filters, setFilters] = useState(defaultFilters);

  const { productOptions } = useProductOptions(false);

  // const [singleTx, setSingleTx] = useState<RedeemTxType | null>(null);

  // const [badge, setBadge] = useState<TransactionBadgeType>({
  //   total: 0,
  //   waiting: 0,
  //   pending: 0,
  //   success: 0,
  //   rejected: 0,
  //   cancel: 0,
  //   failed: 0,
  // });

  const dateError = isAfter(filters.startDate?.toDate(), filters.endDate?.toDate());

  const form = useBoolean(false);
  const reload = useBoolean(false);

  const canReset =
    !!filters.name ||
    filters.productId !== 'all' ||
    filters.status !== 'all' ||
    (!!filters.startDate && !!filters.endDate);

  const {
    currentPage,
    prevPage,
    rowsPerPage,
    meta,
    onSetData,
    onResetPage,
    onChangePage,
    onChangeRowsPerPage,
    data: tableData,
  } = usePagination<RedeemTxType>();

  useEffect(() => {
    const pageDirection = currentPage > prevPage ? 'next' : 'prev';
    const params = {
      ...fDateRange(filters.startDate, filters.endDate),

      type: TransactionType.REDEEM_STOCK,
      productId: filters.productId === 'all' ? undefined : filters.productId,
      status: filters.status === 'all' ? undefined : filters.status,
      page: currentPage,
      limit: rowsPerPage,
      userId: filters.name?.value,
      ...(pageDirection === 'next' && { lastDocId: meta.lastDocId }),
      ...(pageDirection === 'prev' && { firstDocId: meta.firstDocId }),
    };
    handleGetInviteCode(params);
  }, [
    currentPage,
    rowsPerPage,
    filters.startDate,
    filters.endDate,
    filters.status,
    filters.productId,
    reload.value,
    filters.name,
  ]);

  const handleGetInviteCode = useCallback(async (params: ParamsType) => {
    try {
      initialize.onTrue();
      // const { data: _badge } = await axios.get<TransactionBadgeType>(
      //   endpoints.transactions.badges,
      //   {
      //     params: {
      //       type: TransactionType.REDEEM_STOCK,
      //     },
      //   }
      // );
      // setBadge(_badge);
      const { data } = await axios.get<Pagination<RedeemTxType>>(endpoints.transactions.get, {
        params: fParams(params),
      });
      onSetData(data);
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  }, []);

  // const handleGetTransactionById = useCallback(async (id: string) => {
  //   try {
  //     loading.onTrue();

  //     const { data } = await axios.get<RedeemTxType>(endpoints.transactions.getById(id));
  //     // setSingleTx(data);
  //   } catch (error) {
  //     toastError(error);
  //   } finally {
  //     loading.onFalse();
  //   }
  // }, []);

  const handleFilters = useCallback(
    (name: GoldWithdrawFilterKey, value: GoldWithdrawFilterValue) => {
      onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    []
  );

  const handleResetFilters = useCallback(() => {
    onResetPage();
    setFilters(defaultFilters);
  }, []);

  const handleReload = useCallback(() => {
    onResetPage();
    // if (rootReload) {
    //   rootReload();
    // }
    reload.onToggle();
  }, []);

  // const tabs: StatusTabFilterOption = useMemo(
  //   () => [
  //     { value: 'all', label: 'ทั้งหมด', color: 'default', count: badge.total },
  //     {
  //       value: TransactionStatus.SUCCESS,
  //       label: 'สำเร็จ',
  //       color: 'success',
  //       count: badge.success,
  //     },
  //     {
  //       value: TransactionStatus.PENDING,
  //       label: 'รอดำเนินการ',
  //       color: 'warning',
  //       count: badge.pending,
  //     },
  //     {
  //       value: TransactionStatus.REJECTED,
  //       label: 'ปฏิเสธ',
  //       color: 'error',
  //       count: badge.rejected,
  //     },
  //     // {
  //     //   value: TransactionStatus.CANCEL,
  //     //   label: 'ยกเลิก',
  //     //   color: 'info',
  //     //   count: badge.cancel,
  //     // },
  //   ],
  //   [badge]
  // );

  return (
    <Container>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" gutterBottom>
            รายการส่งออก
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={form.onTrue}
          >
            สร้างรายการส่งออก
          </Button>
        </Stack>

        <Card>
          {/* <StatusTabFilter
            value={filters.status}
            onChange={(newValue) => handleFilters('status', newValue)}
            options={tabs}
          /> */}

          {/* <Stack direction="row" justifyContent="space-between" alignItems="center" pr={2.5}> */}
          <StockExportTableToolbar
            filters={filters}
            onFilters={handleFilters}
            dateError={dateError}
            productOptions={productOptions}
            onCreateRedeem={form.onTrue}
          />

          {/* {user && (
              <Button
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={form.onTrue}
                sx={{ width: '100%', maxWidth: 200 }}
              >
                สร้างรายการถอนสินค้า
              </Button>
            )}
          </Stack> */}

          {canReset && (
            <StockExportTableFiltersResult
              filters={filters}
              onFilters={handleFilters}
              onResetFilters={handleResetFilters}
              results={meta.totalResults}
              sx={{ p: 2.5, pt: 0 }}
              productOptions={productOptions}
            />
          )}

          <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
            <Scrollbar>
              <Table sx={{ minWidth: 800 }}>
                <TableHeadCustom headLabel={tableHead} />

                <TableBody>
                  <TableLoading loading={initialize.value} rows={rowsPerPage}>
                    {tableData.map((row) => (
                      <StockExportTableRow key={row.id} row={row} handleReload={handleReload} />
                    ))}

                    <TableEmptyRows
                      show={!initialize.value}
                      height={76}
                      emptyRows={emptyRows(currentPage, rowsPerPage, meta.totalResults)}
                    />

                    <TableNoData notFound={!tableData.length} />
                  </TableLoading>
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>

          <TablePaginationCustom
            count={meta.totalResults}
            page={currentPage}
            rowsPerPage={rowsPerPage}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
          />
        </Card>
      </Stack>
      {!!form.value && (
        <StockExportCreateDialog
          open={form.value}
          onClose={form.onFalse}
          handleReload={handleReload}
          // openApproveDialog={(txId) => {
          //   (async () => {
          //     if (txId) {
          //       await handleGetTransactionById(txId);
          //       approve.onTrue();
          //     }
          //   })();
          // }}
        />
      )}

      {/* {!!approve.value && !!singleTx && (
        <StockExportApproveDialog
          isCreateAndApprove={isCreateAndApprove}
          open={approve.value}
          onClose={approve.onFalse}
          handleReload={handleReload}
          tx={singleTx}
        />
      )} */}

      <LoadingDialog open={loading.value} />
    </Container>
  );
}
